<template>
  <a
    v-if="href"
    :class="componentClasses"
    :href="href"
  >
    <div class="stk-link-slot">
      <Icon
        v-if="iconBefore"
        class="stk-button-icon-before"
        :icon="iconBefore"
      />
      <slot />
    </div>
  </a>
  <router-link
    v-else-if="to"
    :class="componentClasses"
    :to="to"
  >
    <div class="stk-link-slot">
      <Icon
        v-if="iconBefore"
        class="stk-button-icon-before"
        :icon="iconBefore"
      />
      <slot />
    </div>
  </router-link>
  <button
    v-else
    :class="componentClasses"
    @click="$emit('click', $event)"
  >
    <div class="stk-link-slot">
      <Icon
        v-if="iconBefore"
        class="stk-button-icon-before"
        :icon="iconBefore"
      />
      <slot />
    </div>
  </button>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import Icon from '@stakeui/graphic/icon/Icon.vue';

const props = defineProps({
  to: {
    type: Object,
  },
  href: {
    type: String,
  },
  iconBefore: {
    type: String,
  },
  iconBefore: {
    type: String,
  },
  underlined: {
    type: Boolean,
  },
  noUnderline: {
    type: Boolean,
  },
  size: {
    type: String,
  }
});

const componentClasses = computed(() => [
  'stk-link',
  props.href ? `has-href` : '',
  props.size ? `stk-size-${props.size}` : '',
  props.underlined ? `with-line` : '',
  props.noUnderline ? `no-underline` : '',
]);
</script>

<style>
.stk-link {
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  vertical-align: top;

  &.with-line,
  &:hover {
    .stk-link-slot::after {
      transform: none;
    }
  }

  &.no-underline .stk-link-slot::after  {
    display: none;
  }
}

.stk-link-slot {
  position: relative;

  &::after {
    background-color: currentColor;
    content: "";
    height: 1px;
    position: absolute;
    top: 100%;
    left: 0;
    transition-duration: calc(2 * var(--stk-transition-duration));
    transition-property: transform;
    transform: scaleX(0);
    transform-origin: left center;
    width: 100%;
  }
}
</style>
